// extracted by mini-css-extract-plugin
export default {"productGrid":"DZ-z","centerLink":"EZ-z","productSection":"FZ-z","item":"GZ-z","ctaButton":"HZ-z"};